module.exports = __webpack_public_path__ + "img/1@2x.24f3ef8e.png";